import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from "rxjs"
import { map, catchError, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TabVM, DocdefDataVM, NJDocData, NJDocDefTemplate, modalParams, ModalParamsElem, AutoCompleteTextBoxEntry, DOData, childSearchReq } from "./DocDefPrimLib/DOData";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { GridInternalAgGridComponent, NJReadDocDefTemplateLookup } from 'projects/doc-def-prim-lib/src/public-api';
//import { Session } from 'inspector';

@Injectable({
    providedIn: 'root'
})
export class DocDefPrimLibService implements CanActivate {
    public apiBaseName: string;
    public ApiDocDefPrimController: string;
    public ProjBaseName: string;
    public UserName: string;
    public postResp;
    public token: string
    public LoaderKey: string;
    public gridDataVM: DocdefDataVM;
    public gridData: Array<NJDocData>;
    public ReportdDataVM: string;
    public TabVM: TabVM;
    public saveRet: string;
    public securityCodeMatches: boolean;
    public lstAutoCompleteTextBoxEntry: Array<AutoCompleteTextBoxEntry>;
    public lstDynamicLookup: Array<NJReadDocDefTemplateLookup>;
    ///CommunicationServiceMethod
    invokeCommunicationServiceMethod = new EventEmitter();
    ApiBaseUri: any;
    CommunicationServiceMethod(params: any = '') {
        this.invokeCommunicationServiceMethod.emit(params);
    }

    public ClearCacheReturn: number;


    //// Implementation for setting pages to READ ONLY -------

    /*
    private await sha256(message) {
        // encode as UTF-8
        const msgBuffer = new TextEncoder().encode(message);

        // hash the message
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

        // convert ArrayBuffer to Array
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        // convert bytes to hex string
        const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
        console.log(hashHex);
        return hashHex;
    }
    

    private hash(str: string): number { // replace with something stronger
        return str.split('').reduce((prevHash, currVal) =>
            (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0);
    }

    private _sessionIsUserReadOnly: string = "";
    private extraText: string = "&hgte$e" + this.UserName;  // for hashing - so each user's valid hash is different
    private sessionKey = "1"; // set the key to "1" so a peering user doesn't know what it is for ("1" = User can edit; anything else is read only
    public get userIsReadOnly(): boolean {
        let hashedValue = this.hash("TRUE" + this.extraText).toString();
        let storedValue = sessionStorage.getItem(this.sessionKey); 
        return (hashedValue == storedValue) ? false : true;
    }
    public set userIsReadOnly(value: boolean) {
        let canWrite: boolean = !value;
        let hashedValue = this.hash(canWrite.toString().trim().toUpperCase() + this.extraText).toString();
        sessionStorage.setItem(this.sessionKey, hashedValue); 
    }

    private _isUserREADONLY: boolean = false;

    public setupCSOCReadOnlyStatus(loaderKey: string) { 
        this.checkSecurity("CSOCREADONLY", loaderKey);
    }

    get isUserReadOnly(): boolean {  // public property to check to see if this user is READ ONLY
        return this._isUserREADONLY;
    }
    */
    /*
    public disableTemplates(listDocdata: Array<Array<DOData>>): Array<Array<DOData>> {
        listDocdata.forEach(ldo => {
            ldo.forEach(d => {
                switch (d.njDocDefTemplate.tType.trim().toUpperCase()) {
                    case "GRID":   // Do not disable these
                    case "GRID1":
                    case "GRID2":
                    case "GRID3":
                    case "GRID4":
                    case "ACCORDION":
                    case "LINK":
                    case "AUTHORIZATIONGRID":
                        break;
                    case "BUTTON":
                        if (d.njDocData.dataValue.trim().toUpperCase() != "CANCEL") // Do not disable CANCEL buttons
                            d.isEnabled = false;
                        break;
                    default:  // Disable everything else
                        d.isEnabled = false;
                        break;
                }
            });
        });
        return listDocdata;
    }
    // overload of above - but Typescript won't let you overload a method name (unfortunately)

    public disableTabTemplates(listDocdata: Array<DOData>, lstExceptions: Array<string> = null, overloaded=null): Array<DOData> {
        var lst: Array<Array<DOData>> = new Array<Array<DOData>>();
        lst.push(listDocdata);
        lst = this.disableTemplates(lst, lstExceptions);
        return lst[0];
    }
    public set userIsReadOnly(value: boolean) {
        this.userIsReadOnly_String.toUpperCase() == "TRUE";
        //this._userIsREADONLY = value;
    }

    private checkSecurity(secCode: string, loaderKey: string) {
        this.checkIfCodeInUserSecurity(secCode, loaderKey)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        switch (secCode) {
                            case "CSOCREADONLY":
                                this.userIsReadOnly = true;
                                break;
                            default:
                                this.userIsReadOnly = false;
                                break;
                        }
                    }
                },
                (err: any) => console.log(err),
                () => { }
            );
    }
    public setupCSOCReadOnlyStatus(loaderKey: string) {
        this.checkSecurity("CSOCREADONLY", loaderKey);
    }
*/



    public userIsReadOnly_String: string = "";  // from app.component
    public get userIsReadOnly(): boolean {
        return this.userIsReadOnly_String.toUpperCase() == "TRUE";
    }

    // listDocdata - localList of DocData
    // lstExceptions - list of Exceptions (template codes that should not be disabled)
    // Any templates that should not be disabled should have the "EnabledWhenReadOnly" 
    public disableTemplates(listDocdata: Array<Array<DOData>>, lstExceptions: Array<string> = null): Array<Array<DOData>> {
        listDocdata.forEach(ldo => {
            ldo.forEach(d => {
                let isException: boolean = false;
                if (lstExceptions) // Is this Template in the Exception List?
                    isException = (lstExceptions.filter(t => t == d.njDocDefTemplate.templateCode).length > 0); 
                if (!isException)  // Does this template have EnabledWhenReadOnly custom parameter set to true or yes?
                    if (d.customParameters["EnabledWhenReadOnly"] != undefined)
                        isException = d.customParameters["EnabledWhenReadOnly"].trim().toUpperCase() == "TRUE" || d.customParameters["EnabledWhenReadOnly"].trim().toUpperCase() == "YES";
                if (!isException) { 
                    switch (d.njDocDefTemplate.tType) {
                        case "TextBox":  // Disable these TTypes
                        case "TextBoxSng":
                        case "DropDown":
                        case "Date":
                        case "GridNCheckBox":
                        case "GridNRadio":
                        case "Grid2CheckBox":
                        case "Button":
                            d.isEnabled = false;
                            break;
                        default:  
                            break;
                    }
                }
            });
        });
        return listDocdata;
    }


    // --------------------------------------------

    //WelcomeVM: import("C:/HTML5/CyberAng_1_0_0/CyberAng_1_0_0/Welcome/src/app/shared/WelcomeVM").WelcomeVM;


    //closeResult: string;
    //modalOptions: NgbModalOptions;
    constructor(private http: HttpClient, private modalService: NgbModal, private router: Router) {
        //this.modalOptions = {
        //    backdrop: 'static',
        //    backdropClass: 'customBackdrop'
        //};
    }

    private extractData(response: Response) {
        //let body = response.json();
        //body.then(function (data) {
        //    this.postResp = data;
        //});
        this.postResp = response;
        return true;
    }
    private handleError(error: Response): Observable<any> {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(err => of('server error found'));
    }
    ///////////////////////////////////////////// GetSaveLoader /////////////////////////////////////////////
    GetSaveLoader(loaderKey: string): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }),
            //params: new HttpParams()
            //    .set('loaderKey', loaderKey)
        };
        //    return this.http.get(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/GetSaveLoader", httpOptions);
        //}
        return this.http.get(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/GetSaveLoader?loaderKey=" + loaderKey
            , httpOptions)
            .pipe(map((data: string) => {
                return this.GetSaveLoaderVM.call(this, data)
            }
            ));

    }
    GetSaveLoaderVM(data: string): boolean {
        this.saveRet = data;
        return true;
    }
    ///////////////////////////////////////////// GetSaveLoader /////////////////////////////////////////////

    ///////////////////////////////////////////// CheckIfCodeInUserSecurity //////////////////////////////////////////

    checkIfCodeInUserSecurity(secCode: string, loaderKey: string, permissions = null): any {

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }),
            params: new HttpParams()
                .set('secCode', secCode)
                .set('loaderKey', loaderKey)
                .set('permissions', permissions)
        };
        return this.http.get(this.apiBaseName + "api/ApiDocDefPrim/CheckIfCodeInUserSecurity", httpOptions);
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////// GetWelcomeVM /////////////////////////////////////////////
    loadTab(params: modalParams
    ): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/GetTabVM", params
            , httpOptions)
            .pipe(map((data: TabVM) => {
                return this.getWelcomeVM.call(this, data)
            }
            ));
    }
    getWelcomeVM(data: TabVM): boolean {
        this.TabVM = data;
        return true;
    }
    ///////////////////////////////////////////// GetWelcomeVM /////////////////////////////////////////////
    ///////////////////////////////////////////// Call Zip Modal /////////////////////////////////////////////
    //openZipComp(zip:string ) {
    //    const modalRef = this.modalService.open(ModalZipComponent, this.modalOptions);
    //    modalRef.componentInstance.modal_zip_title = 'I am your title:';
    //    modalRef.componentInstance.modal_zip_content = 'I am your content';
    //    modalRef.componentInstance.zip = zip;
    //    modalRef.result.then((result) => {
    //        if (result) {
    //            console.log(result);
    //        }
    //    }, (reason) => {
    //        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //        console.log(this.closeResult);
    //    }
    //    );
    //}

    //private getDismissReason(reason: any): string {
    //    if (reason === ModalDismissReasons.ESC) {
    //        return 'by pressing ESC';
    //    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    //        return 'by clicking on a backdrop';
    //    } else {
    //        return `with: ${reason}`;
    //    }
    //}
    ///////////////////////////////////////////// Call Zip Modal /////////////////////////////////////////////
    ///////////////////////////////////////////// getCompositeData /////////////////////////////////////////////
    //  getCompositeData(ApiController: string, LastAccodionButon: string, loaderKey: string): Observable<boolean> {
    //      const httpOptions = {
    //          headers: new HttpHeaders({
    //              'Content-Type': 'application/json',
    //              'Authorization': 'Bearer ' + this.token,
    //              'Cache-Control': 'no-cache',
    //              'Pragma': 'no-cache',
    //              'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //          })
    //      };
    //      return this.http.get(this.apiBaseName + "api/" + ApiController + "/GetCompositeData?LastAccodionButon=" + LastAccodionButon +  '&loaderKey=' + loaderKey  , httpOptions)
    //          .pipe(map((data: TabVM) => {
    //              return this.CompositeDataVM.call(this, data)
    //          }
    //          ));
    //  }
    //  CompositeDataVM(data: TabVM): boolean {
    //      this.TabVM = data;
    //      return true;
    //  }
    /////////////////////////////////////////////// getCompositeData /////////////////////////////////////////////
    ///////////////////////////////////////////// Save DocDef Array /////////////////////////////////////////////
    saveDocDefData(DocData: DocdefDataVM): Observable<boolean> {
        DocData.UserName = this.UserName;
        if (DocData.loaderKey == null || DocData.loaderKey == "")
            DocData.loaderKey = this.LoaderKey;
        return this.doSaveDocDefData(DocData);
    }
    private doSaveDocDefData(DocDate: DocdefDataVM): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        //Performance Improvement : separate post docdef call for FSS App and FSSPIF
        if (DocDate.loaderKey == "clsDocDefLoaderFSSApp" || DocDate.loaderKey == "clsDocDefLoaderPROV_DET_FSSPIF") {
            return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/PostDocDefDataFSS", DocDate, httpOptions)
                .pipe(map((data: any[]) => {
                    return this.extractData.call(this, data)
                }),
                    tap(data => console.log('doSaveDocDefData: ' + JSON.stringify(data))),
                    catchError(this.handleError))

        }
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/PostDocDefData", DocDate, httpOptions)
            .pipe(map((data: any[]) => {
                return this.extractData.call(this, data)
            }),
                tap(data => console.log('doSaveDocDefData: ' + JSON.stringify(data))),
                catchError(this.handleError))
    }
    ///////////////////////////////////////////// Save DocDef Array /////////////////////////////////////////////

    ///////////////////////////////////////////// GetGenerateSSRSReportStreamData /////////////////////////////////////////////

    loadGenerateSSRSReportStream(params: modalParams): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/GetGenerateSSRSReportStream", params, httpOptions)
            .pipe(map((data: string) => {
                return this.getGenerateSSRSReportStream.call(this, data)
            }
            ));
    }
    getGenerateSSRSReportStream(data: string): boolean {
        this.ReportdDataVM = data;
        return true;
    }
    ///////////////////////////////////////////// GetGenerateSSRSReportStreamData /////////////////////////////////////////////
    ///////////////////////////////////////////// retrieveAutoCompleteData /////////////////////////////////////////////

    getAutoCompleteData(DocData: DocdefDataVM): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }),
            params: new HttpParams()
                .set('lock', 'no')
        };
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/PopulateAutoCompleteText" ,DocData, httpOptions)
            .pipe(map((data: Array<AutoCompleteTextBoxEntry>) => {
                return this.GeneratAutoCompleteData.call(this, data)
            }
            ));
    }
    GeneratAutoCompleteData(data: Array<AutoCompleteTextBoxEntry>): boolean {
        this.lstAutoCompleteTextBoxEntry = data;
        return true;
    }
    ///////////////////////////////////////////// retrieveAutoCompleteData /////////////////////////////////////////////
    ///////////////////////////////////////////// retrieveDynamicLookupData /////////////////////////////////////////////

    getDynamicLookupData(DocData: DocdefDataVM): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }),
            params: new HttpParams()
                .set('lock', 'no')
        };
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/PopulateDynamicLookupData", DocData, httpOptions)
            .pipe(map((data: Array<NJReadDocDefTemplateLookup>) => {
                return this.GenerateDynamicLookupData.call(this, data)
            }
            ));
    }
    GenerateDynamicLookupData(data: Array<NJReadDocDefTemplateLookup>): boolean {
        this.lstDynamicLookup = data;
        return true;
    }
    ///////////////////////////////////////////// retrieveDynamicLookupData /////////////////////////////////////////////
    ///////////////////////////////////////////// set loader member id /////////////////////////////////////////////
    public doSetLoaderMemberId(DocData: DocdefDataVM): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/SetLoaderMemberId", DocData, httpOptions)
            .pipe(map((data: any[]) => {
                return data;
            }));
    }
    ///////////////////////////////////////////// set loader member id /////////////////////////////////////////////
    ///////////////////////////////////////////// loadGridData /////////////////////////////////////////////
    loadGridData(templateCode: string, params: any, loaderKey: string, cutoffDate: string="", parentKey: string=""): Observable<boolean> {
        if (!loaderKey) {
            loaderKey = this.LoaderKey;
        }
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.get(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/GetGridData?GridTemplateCode=" + templateCode + '&param=' + JSON.stringify(params) + '&LoaderKey=' + loaderKey + '&cutoffDate=' + cutoffDate + '&parentKey=' + parentKey, httpOptions)
            .pipe(map((data: DocdefDataVM) => {
                return this.getloadGridVM.call(this, data)
            }
            ));
    }
    getloadGridVM(data: DocdefDataVM): boolean {
        this.gridDataVM = data;
        return true;
    }
    ///////////////////////////////////////////// loadGridData /////////////////////////////////////////////
    
    ///////////////////////////////////////////// GetGridDataSP /////////////////////////////////////////////
    loadGetGridDataSP(APIPageController: string, GridTemplateCode: string, sortModel: any): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.get(this.apiBaseName + "api/" + APIPageController + "/GetGridDataSP?LastAccodionButon=" + GridTemplateCode + '&sortModel=' + JSON.stringify(sortModel), httpOptions)
            .pipe(map((data: Array<NJDocData>) => {
                return this.getGridDataSP.call(this, data)
            }
            ));
    }
    getGridDataSP(data: Array<NJDocData>): boolean {
        this.gridData = data;
        return true;
    }
  ///////////////////////////////////////////// GetGridDataSP /////////////////////////////////////////////

    clearCache( loaderKey: string): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.get(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/ClearCache?loaderKey=" + loaderKey, httpOptions)
            .pipe(map((data: number) => {
                return this.getCCData.call(this, data)
            }
            ));
    }
    getCCData(data: number): boolean {
        this.ClearCacheReturn = data;
        return true;
    }

    // Returns the value of a selected column of the SELECTED row of grid data
    // specify the column's template Code
    public getGridTemplateValue(gridComponent: GridInternalAgGridComponent, templateCode: string): any {
        var templateID: number = -1;
        var tNumber: string = "";
        gridComponent.lstChildDocDefTemplate.forEach(ldo => {
            if (ldo.templateCode === templateCode)
                templateID = ldo.docDefTemplateID;
        });
        tNumber = "T" + templateID.toString();
        let templateValue = gridComponent.selectedRow[tNumber];

        // let result = gridComponent.getSelectedRowData();
        // let templateValue = +result[0][tNumber];
        return templateValue;
    }

    /* Define function for escaping user input to be treated as
   a literal string within a regular expression */
    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    /* Define function to find and replace specified term with replacement string */
    replaceAll(str, term, replacement) {
        return str.replace(new RegExp(this.escapeRegExp(term), 'g'), replacement);
    }
    //validate user input against another field
    ValidateInput(DocData: DocdefDataVM, TemplateCode: string): any {
        DocData.action = TemplateCode;
        DocData.UserName = this.UserName;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        var resp;
        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/CustomValidation", DocData, httpOptions)
            .pipe(map((data: any[]) => {
                return data;
            }));
    }
    //clone object
    static createNew(objectToCopy: any): any {
        if (objectToCopy)
            return (JSON.parse(JSON.stringify(objectToCopy)));
        else return undefined;
    }

    //////////////////////////////////// Route Guard //////////////////////////////////////////////
    path: ActivatedRouteSnapshot[];
    route: ActivatedRouteSnapshot;
    private lstComponents: [] = [];

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.lstComponents[next.routeConfig.path]) {
            return this.lstComponents[next.routeConfig.path];
        }
        else
            return false;
    }

    AllowRoute(CompName: string) {
        this.lstComponents[CompName] = true;
    }

    RestrictRoute(CompName: string) {
        this.lstComponents[CompName] = false;
    }

    RemoveAllRoutePermissions() {
        this.lstComponents = [];
    }
    ///////////////////////////////////////// Route Guard ////////////////////////////////////////////

    /////////////////////////////////////////////DOCUMENT UPLOADER////////////////////////////////////////
    private UploadData: File[];
    PrepareUpload(_file: File, newFileName: string, templateCode: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };

        if (!this.UploadData)
            this.UploadData = [];

        this.UploadData.push(_file);

        const lstData = new FormData();
        lstData.append(_file.name, _file, templateCode);

        return this.http.post(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/PrepareUpload", lstData, httpOptions)
            .pipe(map((data: any) => {
                return data;
            }));
    }



    DeleteAttachment(somedata: string): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };

        let fileName: string = somedata;
        return this.http.post<any>(this.apiBaseName + "api/" + this.ApiDocDefPrimController + "/PostDeleteAttachment", fileName, httpOptions)
            .pipe(map((data: any[]) => {
                return data;
            }));

        //this.updateLocalStorage();


    }

    CheckQuickSerachResult(params: childSearchReq): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        };
        return this.http.post<string>(this.apiBaseName + "api/ApiDocDefPrim/CheckQuickSerachResult", params, httpOptions);
    }

    DeleteAllAttachments(): any {
        //console.log('delete all attachments');

        //let lstData: DataModel[] = this.DataToSend.filter(function (d: DataModel)
        //{
        //    return d.TemplateItem.ElementType == "UploadDoc";
        //});
        //return this.http.post(environment.API_URL + '/api/Email/PostDeleteAllAttachments', lstData, this.httpOptions).pipe(map((data: any[]) =>
        //{
        //    this.updateLocalStorage();
        //    return data;
        //}));

        return;
    }


    //////////////////////////////////////////////////////////////////////////////////////////////////////
}
export class UploadVM {
    UploadData: File[];
    TemplateCode: string;
}